import axios from 'axios'

export const downloadFile = async (fileUrl: string, filename: string | null = null) => {
  // Apparently there's no non-hackey way to programatically download files.
  // This generates an anchor element and triggers a click - blergh.

  const response = await axios.get(fileUrl, { responseType: 'blob' })

  // The filename of the download is in the content-disposition header.
  // It looks something like this:
  // 'attachment; filename="UrbanIntelligenceRiskSummaryGeoJSONExport.zip"'
  // (Don't forget to expose the content-disposition header via CORS in the API :-) )
  const contentDisposition = response.headers['content-disposition']

  let filenameToDownload = filename ?? contentDisposition.match(/filename="(.*?)"/)[1]

  const a = document.createElement('a')
  const url = URL.createObjectURL(response.data)
  a.href = url
  a.download = filenameToDownload

  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url)
      removeEventListener('click', clickHandler)
    }, 150)
  }

  a.addEventListener('click', clickHandler, false)
  a.click()
}
